//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[],[[["host","accessKey","secretKey"],"SetMoldex3DCredentials",{},3,0],[["type"],"GetUniqueFilename",{R_:{name:''}},1,0],[["file","type"],"Moldex3D",{R_:{response:''}},2,0]],[]];
SPLM.FileUploadManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.FileUploadManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.FileUploadManager.Type = Object.freeze({
    "Stl" : "Stl", "Nastran" : "Nastran"});

export default SPLM;